/** Record identifiers are UUIDs made ON THE DEVICE, so a record has its final id from the moment it
 * is created offline. (ADHERE used negative temporary ids and a mapping table; a whole class of
 * bugs came from translating them after sync.) */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
export function isUuid(s) {
    return typeof s === 'string' && UUID_RE.test(s);
}
/** RFC 4122 version-4 UUID from the platform CSPRNG. */
export function newId() {
    const c = globalThis.crypto;
    if (typeof c?.randomUUID === 'function')
        return c.randomUUID();
    if (typeof c?.getRandomValues !== 'function')
        throw new Error('No secure random source available');
    const b = c.getRandomValues(new Uint8Array(16));
    b[6] = ((b[6] ?? 0) & 0x0f) | 0x40;
    b[8] = ((b[8] ?? 0) & 0x3f) | 0x80;
    const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
//# sourceMappingURL=ids.js.map